import { styled } from "@mui/system";
import { Box } from "@mui/material";

export const RootContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40vw",
  backgroundColor: theme.palette.background.paper,
  border: "2px solid #000",
  boxShadow: "240px",
  padding: "40px",
}));

export const Header = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  textAlign: "center",
}));

export const ActionsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  mt: "40px",
  borderTop: `1px solid ${theme.palette.divider}`,
  paddingTop: "30px",
  gap: "20px",
}));
